module.exports = __webpack_public_path__ + "3ad6afd506b29d25603655af43df387f.mp3";